/** @jsx jsx */
import React from 'react';
import { css, jsx } from '@compiled/react';
import { Box, Inline, xcss } from '@atlaskit/primitives';
import { DN400 } from '@atlaskit/theme/colors';
import { token } from '@atlaskit/tokens';

export type TimelineEvent = {
	icon: React.JSX.Element;
	iconBackgroundStyles: ReturnType<typeof xcss>;
	title: string;
	description: string;
};

type TimelineProps = {
	timelineEvents: TimelineEvent[];
};
export function Timeline(props: TimelineProps) {
	const { timelineEvents } = props;
	return (
		<>
			{timelineEvents.map((timelineEvent, index) => (
				<Inline key={timelineEvent.title} xcss={TimelineEventContainerStyles}>
					<Inline xcss={TimelineEventStyles} space="space.100">
						<Box xcss={[IconStyles, timelineEvent.iconBackgroundStyles]}>{timelineEvent.icon}</Box>
						<Box xcss={TimelineEventContentStyles}>
							<Inline xcss={TitleStyles}>{timelineEvent.title}</Inline>
							<span>{timelineEvent.description}</span>
						</Box>
					</Inline>
					{index + 1 !== timelineEvents.length && <div css={connectorStyles} />}
				</Inline>
			))}
		</>
	);
}

const IconStyles = xcss({
	border: '2px solid',
	borderRadius: 'border.radius.circle',
	display: 'flex',
	width: '32px',
	height: '32px',
	justifyContent: 'center',
	alignItems: 'center',
	flexShrink: '0',
});

const TimelineEventStyles = xcss({
	display: 'flex',
	alignItems: 'start',
});

const TimelineEventContainerStyles = xcss({
	display: 'flex',
	flexDirection: 'column',
});

const TimelineEventContentStyles = xcss({
	display: 'flex',
	flexDirection: 'column',
});

const TitleStyles = xcss({
	fontWeight: '700',
});

const connectorStyles = css({
	backgroundImage: `linear-gradient(${token('color.icon.disabled', DN400)} 50%, rgba(0,0,0,0) 0%)`,
	backgroundPosition: 'right',
	backgroundSize: '2px 8px',
	backgroundRepeat: 'repeat-y',

	height: `${token('space.600', '40px')}`,
	width: '2px',

	// creates symmetrical visual spacing between the top and bottom timeline items
	marginTop: token('space.negative.100'),

	// centers the connector between the timeline icons
	// eslint-disable-next-line @atlaskit/design-system/use-tokens-space
	marginLeft: '15px',
});
